module.exports = __webpack_public_path__ + "static/media/callout2.2017df42.png";